import { FormControl, FormHelperText, MenuItem, Select } from "@mui/material"
import { useFormContext } from "react-hook-form"

import { FormComponent } from "./FormBuilder/types"
import { useEffect, useState } from "react"

type DropdownProps = {
  field: string
  component: FormComponent
  width?: string
  helperText?: string | undefined
}

export const Dropdown = ({ field, component, width = "450px", helperText }: DropdownProps) => {
  const { register, watch, trigger } = useFormContext()
  const [value, setValue] = useState("")
  const watchedValue = watch(field)

  useEffect(() => setValue(watchedValue ?? ""), [watchedValue])

  const formField = { ...register(field) }

  return (
    <FormControl fullWidth>
      <Select
        defaultValue=""
        disabled={!component.editable}
        sx={{ width }}
        error={!!helperText}
        {...formField}
        value={value}
        onChange={(event) => {
          formField.onChange(event)

          if (component.validateFieldsOnChange?.length) {
            // that's a workaround to move triggering other fields validation
            // down in a callstack, so it is being fired after all potential state updates
            // caused by "onChange"
            setTimeout(() => trigger(component.validateFieldsOnChange))
          }
        }}
      >
        {component?.options?.map((item) => (
          <MenuItem key={item.id} value={item.id}>
            {item.value}
          </MenuItem>
        ))}
      </Select>
      <FormHelperText error>{helperText}</FormHelperText>
    </FormControl>
  )
}
